import { useState } from "react";

export type SubagentEnabled = "on" | "off";
const DEFAULT: SubagentEnabled = "off";
const STORAGE_KEY = "enableSubagent";

export const isSubagentEnabled = () =>
  localStorage.getItem(STORAGE_KEY)?.toLowerCase() === "on";

export function useSubagentState() {
  const [state, setState] = useState<SubagentEnabled>(() =>
    isSubagentEnabled() ? "on" : DEFAULT
  );

  function setSubagentEnabled(next: SubagentEnabled) {
    localStorage.setItem(STORAGE_KEY, next);
    setState(next);
  }

  return [state, setSubagentEnabled] as const;
}
